<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
        <span style="color: red">{{ form.supplierApproveStateInfo }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" v-if="getIsView()" label="采购订单号">
                <el-input disabled readonly v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 采购订单号:{{ form.no }}</span>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="createdUserName" label="发起人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="ownerDeptName" label="所属科室">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
            </el-col> 
          </el-row>

          <el-row>-->
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deptName" v-if="getIsView()" label="需求科室">


                <el-select v-if="system_setting.IsUseWard" v-model="form.deptName" placeholder="请选择"
                  :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards"
                  @change="deptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup"
                    :label="item.deptNo+' '+item.deptName + ' ' + (item.wardName ? item.wardName : '')" :value="item.idGroup"></el-option>
                </el-select>
                <el-select v-else v-model="form.deptName" placeholder="请选择" :disabled="!editMode" style="width: 100%"
                  filterable :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name"
                    :value="item.id"></el-option>
                </el-select>

              </el-form-item>
              <span class="viewText" v-else> 需求科室:{{ form.deptName }}</span>


            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" v-if="getIsView()" label="需求库房">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择需求库房" style="width: 100%"
                  filterable :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 需求库房:{{ form.warehouseName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWarehouseId" v-if="getIsView()" label="收货库房">
                <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode && !purchaseDataDisabled"
                  placeholder="请选择收货库房" style="width: 100%" filterable :filter-method="getOneLevelWarehouseList"
                  @change="oneLevelWarehouseChange">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 收货库房:{{ form.oneLevelWarehouseName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="latestTime" v-if="getIsView()" label="最迟确认日期">
                <el-date-picker v-model="form.latestTime" :disabled="!purchaseDataDisabled" @change="latestTimeChange"
                  size="small" type="date" format="yyyy-MM-dd" style="width: 100%" value-format="yyyy-MM-dd"
                  placeholder="确认日期"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 最迟确认日期:{{  parseTime(new Date(form.latestTime), "{y}-{m}-{d}") }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deliveryTime" v-if="getIsView()" label="要求送达日期">
                <el-date-picker v-model="form.deliveryTime" :disabled="!purchaseDataDisabled" size="small" type="date"
                  format="yyyy-MM-dd" style="width: 100%" value-format="yyyy-MM-dd" placeholder="送达日期"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 要求送达日期:{{  parseTime(new Date(form.deliveryTime), "{y}-{m}-{d}") }}</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="categoryName" v-if="getIsView()" label="采购类型">
                <el-select v-model="form.category" :disabled="!purchaseDataDisabled" placeholder="请选择"
                  @change="categoryEvt" style="width: 100%">
                  <el-option v-for="item in PurchaseCategoryOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <!-- <el-radio-group :disabled="!purchaseDataDisabled" v-model="form.category" style="width:100%">
                  <el-radio v-for="item in PurchaseCategoryOptions" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                </el-radio-group> -->
              </el-form-item>
              <span class="viewText" v-else> 采购类型:{{  PurchaseCategoryOptions.find(item => item.id === form.category)?.name  }}</span>
            </el-col>
            <el-col :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="pressingState" v-if="getIsView()" label="紧急标识">
                <el-select v-if="getIsView()" v-model="form.pressingState" :disabled="!purchaseDataDisabled" placeholder="请选择"
                  style="width: 100%">
                  <el-option v-for="item in OrderPressingOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <span class="viewText" v-else> 紧急标识:{{ form.pressingStateName }}</span>
                <!-- <el-radio-group :disabled="!purchaseDataDisabled" v-model="form.category" style="width:100%">
                  <el-radio v-for="item in PurchaseCategoryOptions" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                </el-radio-group> -->
              </el-form-item>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" v-if="getIsView()" label="供应商">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择" style="width: 100%"
                  filterable :filter-method="(value) => getSuppliers1(value, 1)" @change="supplierChange">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 供应商:{{ form.supplierName }}</span>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="confirm" label="是否确认订单">
                <el-switch v-model="form.confirm" :disabled="!purchaseDataDisabled" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0" />
              
              </el-form-item>
            </el-col> -->

            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="省平台产品大类" v-if="getIsView()" prop="priceMonitorType">
                <el-select v-model="form.priceMonitorType" :disabled="!editMode && !showWorkFlowInfo"
                  placeholder="请选择省平台产品大类" @change="priceMonitorTypeChange" style="width: 100%">
                  <el-option v-for="item in PriceMonitorTypeOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 省平台产品大类:{{ form.priceMonitorTypeName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" v-if="getIsView()" label="总数量">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" v-if="getIsView()" label="总金额">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总金额:{{ form.totalAmount }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" v-if="getIsView()" label="订单状态">
                <el-input disabled v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 订单状态:{{ form.stateName }}</span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="备注" prop="remark">
                <el-input :disabled="!purchaseDataDisabled" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 备注:{{ form.remark }}</span>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">采购订单明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button :class="childMultiple?'btn' :'btn default'" type="danger"  size="small" :disabled="childMultiple" v-preventReClick
              @click="handleDeleteChildForm">删除</el-button>
              <el-button :class="childMultiple?'btn' :'btn default'"  size="small" :disabled="childMultiple" v-preventReClick
              @click="correctProcureNum">修正采购量(按件装量)</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" :max-height="500" style="width: auto; margin: 0 10px"
            @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" :row-class-name="tableRowClassName" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" fixed width="50"> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品" width="180" fixed>
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns2" :placeholder="'请选择产品'"
                  :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList"
                  @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
             
            <el-table-column :show-overflow-tooltip="true" prop="specName" label="产品规格" width="120"
              fixed></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
      
            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="140"></el-table-column>
            <el-table-column prop="number" label="订单数量" width="130">
                <template slot-scope="scope">
                  <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" :id="'number' + scope.$index"
                    @input="inputChange(scope.row)" v-model="scope.row.number"></el-input>
                  <!-- <el-input-number :disabled="!editMode" :id="'number' + scope.$index" @input="inputChange(scope.row)" v-model="scope.row.number" :controls="false" placeholder="请输入数量"></el-input-number> -->
                </template>
              </el-table-column>
            <el-table-column v-if="$route.query.formMode==1" prop="recommendation" label="建议采购量(按件装量)" min-width="170">
                <template slot-scope="scope">
                  {{ scope.row.recommendation?scope.row.recommendation:'' }}
                </template> 
            </el-table-column>
            <el-table-column prop="orderNumber" label="接单数量" width="100"></el-table-column>
            <el-table-column prop="wholeStockQuantity" label="全院库存" width="100"></el-table-column> 
            <el-table-column prop="minUnit" label="最小单位" width="120"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" width="100"></el-table-column>
            <el-table-column  v-if="$route.query.formMode==1" prop="packNumber" label="件装量" width="80">
              <template slot-scope="scope">
                {{ scope.row.packNumber?(scope.row.packNumber+scope.row.minUnit+'/'+scope.row.unit):'' }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="单价" width="130"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column prop="minPrice" v-if="this.system_setting.isUsePriceMonitor" label="平台最低价"
            width="100"></el-table-column>
            <el-table-column prop="undeliveredNumber" label="未配送数量" width="100"></el-table-column>
            <el-table-column prop="unCheckedNumber" label="未收货数量" width="100" />
            <el-table-column prop="inStockNumber" label="入库数量" width="100"></el-table-column>

            <el-table-column prop="productRegistCertName" label="产品注册证" width="130"></el-table-column>
            <el-table-column prop="productCode" label="商品代码" width="100"></el-table-column>
            <el-table-column prop="newProductId"  label="平台产品id" width="100"></el-table-column>
            <el-table-column prop="expectedDate" label="预计送达日期" width="150">
              <template slot-scope="scope">
                {{
                  scope.row.expectedDate
                    ? parseTime(new Date(scope.row.expectedDate), "{y}-{m}-{d}")
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" :disabled="!editMode" width="200">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
               <el-table-column v-if="system_setting.isShowSecondSupplier" prop="secondSupplierName" show-overflow-tooltip
            width="140" label="二级供应商">
            <template slot-scope="scope">
              {{ scope.row.secondSupplierName?scope.row.secondSupplierName:'-' }}
            </template>
          </el-table-column>
            <el-table-column fixed="right" width="160" label="完成情况">
              <template slot-scope="scope">
                <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(
                  scope.row.inStockNumber,
                  scope.row.orderNumber
                )
                  " color="#42b983" />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申请明细</span>
          </div>

          <el-table ref="childTable" border :data="applyDetails" style="width: auto; margin: 0 10px" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column prop="deptName" label="科室名称" width="120"></el-table-column>
            <el-table-column prop="warehouseName" label="仓库名称" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productName" label="产品" width="140"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specName" label="产品规格" width="130"></el-table-column>
            <!-- <el-table-column prop="brand" label="品牌" width="100"></el-table-column> -->
            <el-table-column prop="packSpec" label="包装规格" width="100"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
            <el-table-column prop="stockNumber" label="库存数量" width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家"
              width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商"
              width="180"></el-table-column>
            <el-table-column prop="number" label="申请数量" width="180"></el-table-column>
            <!-- <el-table-column prop="receivedNumber" label="已领数量" width="180"></el-table-column>
            <el-table-column prop="notReceivedNumber" label="未领数量" width="180"></el-table-column>
            <el-table-column prop="actualOrderNumber" label="采购数量" width="120"> -->
            <!-- <template slot-scope="scope">
              <el-input :disabled="!editMode && !purchaseNumberDisabled" placeholder="请输入数量" type="number" min="0" @input="applyDetailNumberChange(scope.row)" v-model="scope.row.actualOrderNumber"></el-input>
            </template>
            </el-table-column> -->
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" max-width="200" />
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom" v-if="form.state == 2">
      <!-- v-if="editMode" -->
      <el-button class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      <el-button class="btn primary" type="primary" v-preventReClick @click="confirmOrder">同意部分接单</el-button>
      <el-button class="btn default" @click="cancelOrder" v-preventReClick>拒绝部分接单</el-button>
    </div>
    <div slot="footer" class="footer-bottom" v-else>
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
        @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
       <el-button v-if="form.state==10" class="btn primary" type="primary" v-preventReClick @click="confirmOrder">确认关闭</el-button>
      <el-button v-if="form.state==10"  class="btn default" @click="cancelOrder" v-preventReClick>拒绝关闭</el-button>
    </div>

    <el-dialog title="集采超量提示" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
      <span>存在集采超量产品，超量明细如下，是否继续？</span>

      <el-table border :data="dialogData" :max-height="400" style="width: auto; margin: 0 10px" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column prop="supplierProductNo" label="产品编码" width="180"></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="180"></el-table-column> 
        <el-table-column prop="specName" label="规格型号" width="180"></el-table-column> 
        <el-table-column prop="number" label="超量数量" width="180"></el-table-column>  
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="excessEvt">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="correctBox" width="400" :before-close="handleClose">
      <h4>您确定对下列产品的采购数量按建议采购量做如下修正吗？</h4>
      <el-table border :data="childMultipleSelection" :max-height="400" style="width: auto; margin: 0 10px" stripe
      :header-cell-style="{ background: '#DDEBFF' }">
      <el-table-column prop="productName" label="产品名称" min-width="110"></el-table-column>
      <el-table-column prop="specName" label="规格型号" min-width="110"></el-table-column>
      <el-table-column prop="number" label="原采购量" min-width="110"></el-table-column>
      <el-table-column prop="recommendation" label="建议采购量(按件装量)" min-width="120"></el-table-column>
      </el-table> 
      <span slot="footer" class="dialog-footer">
        <el-button @click="correctBox = false">取 消</el-button>
        <el-button type="primary" @click="correctEvt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetPurchaseOrderById,
  SavePurchaseOrder,
  RejectPurchaseOrder,
  GetApplyDetailsBySupplierProductId,
  GetPlanDetailsBySupplierProductId,
  ConfirmPurchaseOrder,
  CancelPurchaseOrder,
  ValidateOrderDetail,
  PushPurchaseOrderToProduct,
  PushPurchaseOrderToReagent,
  GetGoods,
  GetVolumeDeclarationDetails,
  GetSupplierProducts,
  PurchaseOrderChaoLiangValidate,
  ValidateSupplierProducts,
  ProTemSave,
  ValidateUnfinishedPurchaseOrderDetail,
  ConfirmPurchaseOrderClose,
  RejectPurchaseOrderClose,
} from "@/api";
import {
  PurchaseCategoryOptions,
  PriceMonitorTypeOptions,
  OrderPressingOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      form: {},
      PurchaseCategoryOptions: PurchaseCategoryOptions,
      PriceMonitorTypeOptions: PriceMonitorTypeOptions,
      OrderPressingOptions: OrderPressingOptions,
      rules: {
        supplierName: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "blur",
          },
        ],
        latestTime: [
          {
            required: true,
            message: "请输入最迟确认日期",
            trigger: "blur",
          },
        ],
        deliveryTime: [
          {
            required: true,
            message: "请输入要求送达日期",
            trigger: "blur",
          },
        ],
        warehouseName: [
          {
            required: true,
            message: "请选择需求库房",
            trigger: "blur",
          },
        ],
        deptName: [
          {
            required: true,
            message: "请选择需求科室",
            trigger: "blur",
          },
        ],
        oneLevelWarehouseId: [
          {
            required: true,
            message: "请选择收货库房",
            trigger: "blur",
          },
        ],
        pressingState: [
          {
            required: true,
            message: "请选择紧急标识",
            trigger: "blur",
          },
        ],
      },
      childFormRules: {
        price: [
          {
            required: true,
            message: "请输入采购价",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "数量不能为空",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectPurchaseOrder,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      warehouseList: [],
      applyDetails: [],
      applyCacheDetails: [],
      purchaseDataDisabled: false,
      purchaseNumberDisabled: false,
      //
      purchaseDetails: [],
      dialogVisible: false,
      dialogData: [],
      correctBox:false
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()

    } else {
      this.getDepts("");
    }

    this.getWarehouses("");
    // this.getProductList("");
    this.getSuppliers1("", 1);
    // this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.purchaseNumberDisabled = true;
      this.purchaseDataDisabled = true;
    },
    // 编辑
    handleUpdate (id) {
      GetPurchaseOrderById({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        if (this.formMode == 1) {
          this.purchaseNumberDisabled = false;
          this.purchaseDataDisabled = false;
        }
        if (this.formMode == 0) {
          // 查看详情时不可写
          this.purchaseNumberDisabled = false;
          this.purchaseDataDisabled = false;
        }

        if (
          this.formMode == 3 &&
          this.form.status == 1 &&
          this.form.approverIds &&
          this.form.approverIds.split(";").indexOf(this.userInfo.id + "") != -1
        ) {
          this.purchaseNumberDisabled = true;
          this.purchaseDataDisabled = true;
        }
      });
    },
    proTemSave () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.supplierApproveState == 4) {
          this.$confirm(
            "您已解除与该供应商的合作关系，不能提交该采购订单",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          );
          return;
        }
        ProTemSave({
          obj: this.form,
          tableCode: this.route.name,
          details: this.form.details,
        }).then((res) => {
          this.$my_message(`暂存成功`, "success");
          if (this.$route.path == this.getMainPath(this.$route.path)) {
            this.open = false;
            this.getData();
          } else {
            sessionStorage.setItem("editMode", 0);
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          }
        });
      });
    },
    //
    checkCortryNumber () {
      const h = this.$createElement;
      let content = [];
      this.purchaseDetails.forEach((res, index) => {
        if (
          res.cortryNumber < this.form.details[index]?.number &&
          this.form.details[index].isTempPurchase == 1
        ) {
          content.push(
            h(
              "p",
              `第${index + 1}行：产品名称 [${res.productName}]超过临采数量${res.cortryNumber
              }不允许下单\n `
            )
          );
        }
      });
      return content;
    },
    // 保存
    submit () {
      
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        let m = this.checkCortryNumber();
        if (m.length != 0) {
          const h = this.$createElement;
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            customClass: "promptBox",
            message: h("div", m),
          })
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        let _this = this
       let ValidateUnfinishedPurchaseOrder = function(){
          ValidateUnfinishedPurchaseOrderDetail(_this.form).then(res=>{
            if (res.returnData.returnData.length>0) {
                    _this.$confirm("提示", {
                            title: "提示",
                            type: "warning",
                            showClose: false,
                            message: res.returnData.returnData.join("\n"),
                        })
                        .then(() => {
                             PurchaseOrderChaoLiang()
                        })
                        .catch(() => {
                            _this.$store.dispatch('SetLoading', false)
                        });
                      }else{
                         PurchaseOrderChaoLiang()
                      }
          })
       }
      let PurchaseOrderChaoLiang = function(){
          PurchaseOrderChaoLiangValidate(_this.form).then(res => {
          if (res.length !== 0) {
            _this.dialogData = res
            _this.dialogVisible = true
          } else {
            _this.save()
          }
        })
      }
      this.checkCortryNumber();
        if (this.form.supplierApproveState == 4) {
          this.$confirm(
            "您已解除与该供应商的合作关系，不能提交该采购订单",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          );
          this.$store.dispatch('SetLoading',false)
          return;
        }
        var valdateResult = this.orderProductDetailRepeatValidate(
          this.form.details
        );

        if (!valdateResult.flag) {
          this.$my_message(valdateResult.msg, "warning");
          this.$store.dispatch('SetLoading',false)
          return;
        }

        const h = this.$createElement;
        let show = false
        let content = [h("p", "")];
        this.form.details.forEach((item, index) => {
          if (item.number < item.recommendation) {
            show = true
            content.push(h("p", `第${index + 1}行：产品名称 [${item.productName
              }] 采购数量不满足件装量要求`))

          }
        })
        if (show) {
          content.push(h("p","如要修改请点击【取消】，如果不修改，请点击【确定】"))
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            showClose: false,
            message: h("div", content),
          }).then(()=>{
         ValidateUnfinishedPurchaseOrder()
          }).catch(()=>{

          })
          this.$store.dispatch('SetLoading',false)
          return
        }
         ValidateUnfinishedPurchaseOrder()
      });
    },
    save(){
      let supplierProductIds = this.form.details.map(
              (e) => e.supplierProductId
            );
            GetSupplierProducts({
              ids: supplierProductIds,
              pageIndex: 1,
              pageSize: 999,
            })
              .then((res) => {
                let msg = "";
                for (let i = 0; i < this.form.details.length; i++) {
                  let sp = res.returnData.data.find(
                    (e) => e.id == this.form.details[i].supplierProductId
                  );
                  // console.log(sp, 'sp', sp.isEnabled != 1, this.form.details[i].number, this.form.details[i].oneLevelStockNumber)
                  if (sp && sp.isEnabled != 1) {
                    msg = `第${i + 1}行：产品名称[${this.form.details[i].productName
                      }] 规格型号[${this.form.details[i].specName
                      }] 的产品 < span style = "color:red" > 已被禁用 < /span>`;
                    break;
                  }
                }

                if (msg) {
                  this.$my_message(msg, "warning");
                  this.$store.dispatch('SetLoading',false)
                  throw msg;
                }
                return GetVolumeDeclarationDetails({
                  SupplierProductIds: supplierProductIds,
                  pageIndex: 1,
                  pageSize: 999,
                });
              })
              .then((res) => {
                let msg = "";
                for (let i = 0; i < this.form.details.length; i++) {
                  let sp = res.returnData.data.find(
                    (e) =>
                      e.supplierProductId == this.form.details[i].supplierProductId
                  );
                  if (
                    sp &&
                    this.form.details[i].number * 1 + sp.purchaseNumber >
                    sp.warnNumber
                  ) {
                    msg += sp.productName + "，";
                  }
                }

                if (msg) {
                  this.$store.dispatch('SetLoading',false)
                  return this.$alert(
                    msg +
                    "产品已达到本年度采购预警阈值，请关注，可根据实际情况追加申报！！"
                  );
                }

                return ValidateSupplierProducts({
                  ids: supplierProductIds,
                });
              })
              .then((res) => {
                if (res.returnData && res.returnData.length > 0) {
                  const h = this.$createElement;
                  let content = [];
                  for (let i = 0; i < this.form.details.length; i++) {
                    res.returnData.forEach((item) => {
                      if (this.form.details[i].supplierProductId == item.key) {
                        content.push(
                          h(
                            "p",
                            `第${i + 1}行：产品名称[${this.form.details[i].productName
                            }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                            }\n`
                          )
                        );
                      }
                    });
                  }
                  content.push(h("p", `不审核仍可下单。`));

                  return this.$confirm("提示", {
                    title: "提示",
                    type: "warning",
                    customClass: "promptBox",
                    message: h("div", content),
                  });
                }
              })
              .then((res) => {
                return SavePurchaseOrder(this.form);
              })
              .then((res) => {
                // 是否需要上传数据到价格监管平台
                var isNeedPushToPriceMonitor =
                  res.returnData.isNeedPushToPriceMonitor;
                if (
                  isNeedPushToPriceMonitor &&
                  res.returnData.status == 2 &&
                  this.system_setting.isAutoSubmitOrderToPriceMonitor
                ) {
                  let id = res.returnData.id;
                  // 上传订单到价格监管平台，流程审批通过的数据直接上传
                  ValidateOrderDetail({
                    ids: [id],
                  }).then((res) => {
                    if (res.returnData) {
                      var exceptionList = res.returnData.exceptionList;
                      var notFinishCompareList =
                        res.returnData.notFinishCompareList;
                      // 提示
                      if (
                        exceptionList.length > 0 ||
                        notFinishCompareList.length > 0
                      ) {
                        const h = this.$createElement;
                        let content = [
                          h(
                            "p",
                            "上传订单到价格监管平台时，检测到此采购订单存在以下异常："
                          ),
                        ];
                        if (exceptionList.length > 0) {
                          // content = [h('p', '以下所选医院采购订单存在价格异常：')]
                          exceptionList.forEach((item) => {
                            content.push(
                              h(
                                "p",
                                {
                                  style: "color:red",
                                },
                                `价格异常`
                              )
                            );
                          });
                        }
                        if (notFinishCompareList.length > 0) {
                          // content = [h('p', '以下所选医院采购订单存在未对照的目录：')]
                          notFinishCompareList.forEach((item) => {
                            content.push(
                              h(
                                "p",
                                {
                                  style: "color:red",
                                },
                                `存在未对照的目录`
                              )
                            );
                          });
                        }

                        content.push(h("p", "确定要继续上传吗？"));

                        this.$confirm("提示", {
                          title: "提示",
                          type: "warning",
                          message: h("div", content),
                        })
                          .then(() => {
                            // 上传订单
                            this.pushOrder(id);
                          })
                          .catch(() => {
                            this.$my_message(`执行成功`, "success");
                            sessionStorage.setItem("editMode", 0);
                            // this.$router.push({ path: this.getMainPath(this.$route.path) });
                            this.routePushWithParams(
                              this.getMainPath(this.$route.path),
                              this.$route.params
                            );
                          });
                      } else {
                        this.pushOrder(id);
                      }
                    } else {
                      // 上传订单
                      this.pushOrder(id);
                    }
                  });
                } else {
                  this.$my_message(`执行成功`, "success");
                  sessionStorage.setItem("editMode", 0);
                  // this.$router.push({ path: this.getMainPath(this.$route.path) });
                  this.routePushWithParams(
                    this.getMainPath(this.$route.path),
                    this.$route.params
                  );
                }
              }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
    },
    excessEvt(){
      this.dialogVisible= false
      this.save()
    },
    pushOrder (id) {
      if (this.form.priceMonitorType == 0) {
        //上传到耗材
        PushPurchaseOrderToProduct({
          ids: [id],
        })
          .then((res) => {
            this.$my_message("上传成功", "success");
          })
          .finally(() => {
            sessionStorage.setItem("editMode", 0);
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          });
      } else if (this.form.priceMonitorType == 1) {
        // 上传到试剂
        PushPurchaseOrderToReagent({
          ids: [id],
        })
          .then((res) => {
            this.$my_message("上传成功", "success");
          })
          .finally(() => {
            sessionStorage.setItem("editMode", 0);
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          });
      }
    },
    resetForm () {
      this.form = {
        totalNumber: 0,
        totalAmount: 0,
        category: 0,
        remark: "",
        details: [],
        confirm: 0,
        latestTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        deliveryTime: "",
        pressingState: 0,
        state: 0,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        priceMonitorType: 0,
         deptName: this.system_setting.IsUseWard?
        `${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:
        this.mySessionStorage.getDeptName(),
        deptId: this.mySessionStorage.getDeptId(),
        warehouseName: this.mySessionStorage.getWarehouseName(),
        warehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.latestTimeChange(this.form.latestTime);
      this.$nextTick(() => {        
        this.getOneLevelWarehouseList('')
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
 
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(
        this.getMainPath(this.$route.path),
        this.$route.params
      );
    },

    // 明细表
    handleAddChildForm () {
      if (!this.form.oneLevelWarehouseName && !this.form.category && !this.form.supplierName) {
        this.$message({
          message: '请选择收货库房、采购类型、供应商后再新增明细',
          type: 'warning'
        });
        this.getProductList('')
        return
      }
      if (this.form.category == 1) {
        this.getProductList("", "", 1);
      } else {
        this.getProductList("", "", 0);
      }
     
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.childForm.isVoided = false
      this.form.details.push(this.childForm);
      this.autoTotalAmount();

      // this.getProductList('')
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.purchaseDetails = [];
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // // 打开子表弹窗
      // this.openSubformModal = true;
      // this.editChildren = true;
      // this.resetDetailFormData();
      // this.childForm = JSON.parse(JSON.stringify(row));
      // this.childForm.details.forEach((e, index) => {
      //   e.$index = index + 1;
      // });
      this.showApplyData(row);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductId: "",
        specId: "",
        brand: "",
        supplierId: "",
        manufacturerId: "",
        unit: "",
        minUnit: "",
        stockNumber: 0,
        number: 1,
        price: 0,
        orderNumber: 0,
        undeliveredNumber: 0,
        unCheckedNumber: 0,
        inStockNumber: 0,
        amount: 0,
        remark: "",
      };
      
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList("");
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      this.childForm.notReceivedNumber = this.childForm.number;
      this.childForm.planOrderNumber = this.childForm.number;
      this.childForm.actualOrderNumber = this.childForm.number;
      this.autoAmount();
      this.autoTotalAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    deptChange (val) {
      this.form.deptId = val;
      this.getOneLevelWarehouseList("");
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isVoided) {
        return 'through'
      }
      if (row.isVoided == undefined) {
        return 'warning-row'
      }
    },
    deptChange1 (val) {
      let arr = this.STATIC_DeptAndWards.filter(res => res.idGroup == val)
      this.form.deptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.getOneLevelWarehouseList("");
    },
    warehouseChange (val) {
      this.form.warehouseId = val;
      this.form.details = []
    },

    supplierChange (val) {
      this.form.supplierId = val;
      // if (this.form.category == 1) {
      //   this.getProductList("", "", 1);
      // } else {
      //   this.getProductList("", "", 0);
      // }
      this.form.details = [];
    },
    priceMonitorTypeChange (varl) {
      this.getProductList("");
      this.form.details = [];
    },
    productChange (row, val) {
      console.log(val);
      this.purchaseDetails.push(val);
      // let arr = this.STATIC_SupplierProducts.filter(item => item.id == val.id)
      let id = row.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      row = Object.assign(row, val); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      row.id = id;
      row.supplierProductId = val.id;
      row.productRegistCertId = val.productRegistCertId
      row.number = val.isTempPurchase == 0 ? 1 : val.cortryNumber;
      row.undeliveredNumber = row.number;
      row.orderNumber = row.number;
      row.unCheckedNumber = row.number;
      row.price = row.purchasePrice;
      row.amount = row.price * row.number;
      row.supplierProductNo = row.no;
      if(row.packNumber){
        if(val.isTempPurchase){
          row.recommendation = this.divideAndConditionallyAddOne(row.number, row.packNumber) * row.packNumber
        }else{
          row.recommendation =  row.packNumber
        }
      }
      row.remark = "";
      this.autoTotalAmount();

      // console.log(row.$index)
      setTimeout(() => {
        document.getElementById("number" + (row.$index - 1)).focus();
        document.getElementById("number" + (row.$index - 1)).select();
      }, 1);
      // 药械数据
      this.getGoods(row, 1);
    },
    getGoods (row, type) {
      // PriceMonitorType ：价格监管平台类型,0耗材，1试剂，2其他
      // type : 1新增 ，2 查看
      var goodsId = row.priceMonitorId;
      if (type == 2) {
        goodsId = row.goodsId;
      }
      let arr = [];
      GetGoods({
        GoodsId: goodsId,
        PriceMonitorType: row.priceMonitorType,
      }).then((res) => {
        if (goodsId == null || goodsId === "") {
          // console.log("row", row)
          // console.log("goodsId", goodsId, row.priceMonitorType)
          // console.log("this.system_setting.isUsePriceMonitor", this.system_setting.isUsePriceMonitor);
        } else {
          row.goodsId = res.returnData.data[0].goodsId;
          row.procurecatalogId = res.returnData.data[0].procurecatalogId;

          arr.push(res.returnData.data[0].maxPrice);
          arr.push(res.returnData.data[0].avgPrice);
          arr.push(res.returnData.data[0].linkageReferencePrice);
          arr = arr.filter((e) => {
            return e != undefined;
          });
          row.minPrice = arr.length > 0 ? Math.min(...arr) : 0;
        }
      });
    },
    inputChange (row) {
      row.amount = (row.price * row.number).toFixed(4) * 1;
      // row.amount = row.price * row.number
      row.undeliveredNumber = row.number;
      row.orderNumber = row.number;
      row.unCheckedNumber = row.number;
      if(row.packNumber){
        row.recommendation = this.divideAndConditionallyAddOne(row.number, row.packNumber) * row.packNumber

      }
      this.autoTotalAmount();
      this.$forceUpdate()

    },
    latestTimeChange (val) {
      if (val) {
        let confirmDate = new Date(val);
        let t = this.parseTime(
          new Date(
            confirmDate.setDate(
              confirmDate.getDate() +
              (this.system_setting.PoDeliveryDateDefault - 0)
            )
          ),
          "{y}-{m}-{d}"
        );
        this.form.deliveryTime = t;
      }
    },

    getProductList (keyWord, num, num1) {
      var supplierId = "";
      if (this.form.supplierId) {
        supplierId = this.form.supplierId;
      }
      let isTempPurchase = num1 == 0 ? num1 : num1 == 1 ? num1 : "";

      // query.pageSize = 50
      // query.pageIndex = 1
      // query.isEnabled = 1
      // query.supplierId = supplierId
      // query.status = 2
      // query.priceMonitorType = this.form.priceMonitorType

      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageSize: 50,
          pageIndex: 1,
          isEnabled: 1,
          supplierId: supplierId,
          status: 2,
          priceMonitorType: this.form.priceMonitorType,
          warehouseId: this.form.oneLevelWarehouseId,
          isTempPurchase: isTempPurchase,
        }
      );
    },
    getOneLevelWarehouseList (keyWord) {
      if (this.form.deptId) {
        this.getOneLevelWarehousesByOneLevelDeptId(keyWord, this.form.deptId);
      } else {
        this.STATIC_OneLevelWarehouses = [];
      }
    },

    applyDetailNumberChange (row) {
      row.amount = row.actualOrderNumber * row.price;

      var arr = this.form.details.filter(
        (e) => e.supplierProductId == this.applyDetails[0].supplierProductId
      );
      if (arr && arr.length > 0) {
        let total = 0;
        this.applyDetails.map((e) => {
          total += e.actualOrderNumber * 1;
        });

        arr[0].number = total;
        arr[0].orderNumber = total;
        arr[0].undeliveredNumber = total;
        arr[0].unCheckedNumber = total;
        arr[0].amount = arr[0].number * arr[0].price;
      }
      var cacheDetail = this.applyCacheDetails.filter((e) => e.id == row.id);
      if (cacheDetail && cacheDetail.length > 0) {
        cacheDetail.map((item) => {
          return row;
        });
      }
      this.autoTotalAmount();
    },
    oneLevelWarehouseChange (val) {
      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
      this.form.details = []
      this.getProductList("");
    },
    categoryEvt () {

      this.form.details = []
    },
    //other
    showApplyData (row) {
      console.log(row, this.applyCacheDetails, "showApplyData");

      var details = this.applyCacheDetails.filter(
        (e) => e.supplierProductId == row.supplierProductId
      );
      if (details && details.length > 0) {
        this.applyDetails = details;
        return;
      }

      if (!this.form.purchasePlanIds || !row.supplierProductId) {
        return;
      }

      // if (this.form.purchasePlanId != null) {
      //   GetApplyDetailsBySupplierProductId({
      //     planId: this.form.purchasePlanId,
      //     supplierProductId: row.supplierProductId,
      //   }).then((res) => {
      //     this.applyDetails = res.returnData;
      //     this.applyCacheDetails = this.applyCacheDetails.concat(this.applyDetails);
      //   });
      // }

      // if (this.form.purchasePlanIds != null || this.form.purchasePlanIds != '') {
      GetPlanDetailsBySupplierProductId({
        planIds: this.form.purchasePlanIds,
        supplierProductId: row.supplierProductId,
      }).then((res) => {
        this.applyDetails = res.returnData;
        this.applyCacheDetails = this.applyCacheDetails.concat(
          this.applyDetails
        );
      });
      // }
    },
    // initNumberDisable () {
    //   // 非请领单生成的采购计划，审批的时候，数量可编辑
    //   GetApplyDetailsByPlanId({ id: this.id })
    //     .then(res => {
    //       if (!res.returnData || res.returnData.length == 0) {
    //         this.purchaseNumberDisabled = true
    //       }
    //     })
    // },

    confirmOrder () {
      if(this.form.state==10){
        this.$confirm("是否确认关闭订单？", "提示", {
        type: "warning",
      }).then(() => {
          return ConfirmPurchaseOrderClose({ id: this.form.id,}) 
      })  .then((res) => {
          if (res.successful) {
            this.$router.push({
              path: this.getMainPath(this.$route.path),
            });
          }
        });
        return
      }
      this.$confirm("接单数量不等于订购数量，是否继续采购？", "提示", {
        type: "warning",
      })
        .then(() => {
          return ConfirmPurchaseOrder({ id: this.form.id,}) 
          })
        .then((res) => {
          if (res.successful) {
            this.$router.push({
              path: this.getMainPath(this.$route.path),
            });
            this.$my_message(` 提交成功`, "success");
          }
        });
    },
    cancelOrder () {
         if(this.form.state==10){
          this.$confirm("是否拒绝关闭订单？", "提示", {
            type: "warning",
          }).then(() => {
            return RejectPurchaseOrderClose({ id: this.form.id,oldState:this.form.oldState});
          }) .then((res) => {
          if (res.successful) {
            this.$router.push({
              path: this.getMainPath(this.$route.path),
            });
          }
        });
        return
         }
 
           CancelPurchaseOrder({ id: this.form.id,})
        .then((res) => {
          if (res.successful) {
            this.$router.push({
              path: this.getMainPath(this.$route.path),
            });
            this.$my_message(` 提交成功`, "success");
          }
        });
    },
    handleClose () {
      this.correctBox = false
      this.dialogVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
/deep/.through {
  color: #000;
  text-decoration: line-through !important;
}
/deep/.through .el-input__inner {
  text-decoration: line-through !important;
}
</style>
<style>
.promptBox {
  width: 800px !important;
  max-height: 300px;
}
.el-table .warning-row {
  background: oldlace;
}
</style>
